/**
 * Get responsive multiplier based on screen resolution
 * @returns {number} Multiplier value based on screen resolution
 */
export function getResponsiveMultiplier() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  
  // Performance optimization: Use higher multipliers (fewer bars) for both Linux and Windows
  // This improves performance while maintaining visual coverage
  
  if (screenWidth > 1920 || screenHeight > 1080) {
    // For 4K and higher resolutions - ~2x fewer bars than original
    return 2.8; // Was 1.4
  } else if (screenWidth > 1440 || screenHeight > 900) {
    // For 1440p and similar high resolutions - ~2x fewer bars than original
    return 3.6; // Was 1.8
  } else if (screenWidth > 1280 || screenHeight > 720) {
    // For 1080p and similar resolutions - ~2x fewer bars than original
    return 4.4; // Was 2.2
  }
  
  // Default for lower resolutions - ~2x fewer bars than original
  return 5.4; // Was 2.7
}

/**
 * Calculate responsive bar width based on screen resolution
 * @param {number} width - Canvas width
 * @param {number} dataArrayLength - Length of audio data array
 * @returns {number} Calculated bar width
 */
export function getResponsiveBarWidth(width, dataArrayLength) {
  return width / dataArrayLength * getResponsiveMultiplier();
}

/**
 * Get responsive gap size between bars
 * @param {number} barWidth - Current bar width
 * @returns {number} Gap size
 */
export function getResponsiveGapSize(barWidth) {
  // Scale gap with bar width, but keep it reasonable
  const baseGap = 1;
  const scaledGap = Math.max(1, Math.min(3, barWidth * 0.1));
  return scaledGap;
}
